@if (guest) {
  <account-page [title]="guest.name">
    <card-component>
      <card-content>
        <guest-form-component
          [requiresSubmit]="false"
          [guest]="guest"
          [submissionHandler]="updateGuest"
        ></guest-form-component>
      </card-content>
    </card-component>
    <raised-button color="primary" (click)="back()"><i class="fa-solid fa-arrow-left"></i> Back</raised-button>
  </account-page>
}
